import { Grid } from "@mui/material";
import React from "react";

type LayoutWrapperProps = {
  children: React.ReactNode;
  itemsPerRow?: number; // how many items per row (on md+ screens)
  spacing?: number;
};

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({
  children,
  itemsPerRow = 2,
  spacing = 2,
}) => {
  const gridSize = Math.floor(12 / itemsPerRow);

  return (
    <Grid container spacing={spacing}>
      {React.Children.map(children, (child) => (
        <Grid size={{ xs: 12, md: gridSize }}>{child}</Grid>
      ))}
    </Grid>
  );
};

export default LayoutWrapper;
